import { Box, Grid, LinearProgress } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'
import { Text } from "@paro.io/base-ui"

import { FURLOUGH_CODE_OPTIONS } from '../../../../shared/constants/paroReferrals'
import ValidatedAutocomplete from '../../../../_global/ValidatedAutocomplete'
import ValidatedInput from '../../../../_global/ValidatedInput'

const StyledProgressBar = styled(LinearProgress)`
  height: 5px;
  max-width: 279px;
`

interface UserProps {
  isCustomReferral: boolean
  isCurrentResident: boolean | null
  isFurloughReferral: boolean
  password: string
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  strength: number
  strengthMsg: string
}

const User = ({
  isCustomReferral,
  isCurrentResident,
  isFurloughReferral,
  strengthMsg,
  strength,
  password,
  setFieldValue,
}: UserProps) => {
  const furloughCodeLabels = FURLOUGH_CODE_OPTIONS.map((furlough_code_options) => furlough_code_options.label)
  const NAME_CHARACTER_LIMIT = 50
  const EMAIL_CHARACTER_LIMIT = 70

  const disabled = !isCurrentResident

  return (
    <>
      <div className="flex pt-3">
        <div className="w-full pr-3">
          <ValidatedInput label="First Name" placeholder="" name="firstName" type="text" className="mb-3" maxLength={NAME_CHARACTER_LIMIT} />
        </div>
        <div className="w-full pl-3">
          <ValidatedInput label="Last Name" placeholder="" name="lastName" type="text" className="mb-3" maxLength={NAME_CHARACTER_LIMIT} />
        </div>
      </div>

      <ValidatedInput label="Email" placeholder="" name="email" type="email" className="mt-3" maxLength={EMAIL_CHARACTER_LIMIT} />

      <div className="flex pt-3">
        <div className="w-full pr-3">
          <ValidatedInput label="Password" type="password" name="password" placeholder="" />
        </div>
        <div className="w-full pl-3">
          <ValidatedInput label="Confirm Password" type="password" name="confirmPassword" placeholder="" />
        </div>
      </div>

      {password && (
        <div className="mt-5 ml-2">
          <StyledProgressBar variant="determinate" value={strength} />
          <Text>{strengthMsg}</Text>
        </div>)}

      {isFurloughReferral ? (
        <Grid item xs={12} md={12}>
          <Box mt={2}>
            <ValidatedAutocomplete
              label="Referral Partner"
              name="furloughCode"
              options={furloughCodeLabels}
              disabled={disabled || isCustomReferral}
              multiple={false}
              onChange={(e, value) => {
                setFieldValue('furloughCode', value, true)
              }}
            />
          </Box>
        </Grid>
      ) : null}
    </>
  )
}

export default User